import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Angular2TokenService } from 'angular2-token';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { NewsComponent } from './news/news.component';
import { DogsComponent } from './dogs/dogs.component';
import { GalleryComponent } from './gallery/gallery.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FileUploadService } from './file-upload.service';
import { Globals } from './globals';

const appRoutes: Routes = [
  { path: 'Home', component: HomeComponent },
  { path: 'News', component: NewsComponent },
  { path: 'Dogs', component: DogsComponent },
  { path: 'Gallery', component: GalleryComponent },
  { path: '',   redirectTo: '/Home', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }

];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NewsComponent,
    DogsComponent,
    GalleryComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true }
    ),
    HttpClientModule,
    FormsModule,
    HttpModule
  ],
  providers: [Angular2TokenService, FileUploadService, Globals],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/app.module.ts